export const mobility_legislation = [
  {
    id: 1,
    name: 'Road Transportation Act 74 of 1977',
    summary: 'shortsummary/Road Transportation Act 74 of 1977.html',
    link: 'Road Transportation Act 74 of 1977.pdf',
    audio_en: 'audio/en/Road Transportation Act 74 of 1977_en.mp3',
    audio_af: 'audio/af/Road Transportation Act 74 of 1977_af.mp3',
    audio_xh: 'audio/xh/Road Transportation Act 74 of 1977_xh.mp3'
  }
];